// src/pages/UserProfile.js
import React, { useState } from 'react';
import { Box, Grid, Container, Typography, Avatar, Button, TextField, List, ListItem, ListItemText, Card, CardContent } from '@mui/material';

// 模拟一些数据
const userData = {
    name: '张三',
    profession: '前端开发工程师',
    company: '某公司',
    avatar: 'https://via.placeholder.com/100',
    postsLikedCount: 50,
    followersCount: 100,
    footprints: {
        jobsViewed: 20,
        resumesViewed: 15,
    },
    userPosts: [
        '发布的动态1',
        '发布的动态2',
    ],
    userFavorites: [
        '收藏的动态1',
        '收藏的动态2',
    ],
    userLiked: [
        '点赞的动态1',
        '点赞的动态2',
    ],
    friends: ['好友1', '好友2', '好友3'],
    education: ['某大学 - 计算机科学学士'],
    workExperience: ['公司A - 前端工程师', '公司B - 后端工程师'],
};

export default function UserProfile() {
    const [user, setUser] = useState(userData);
    const [isEditing, setIsEditing] = useState(false);

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <Box sx={{ padding: '20px' }}>
            <Container maxWidth="lg" sx={{ marginTop: 4, marginBottom: "120px" }}>
                <Grid container spacing={2}>
                    {/* 左侧栏 - 个人信息卡片 */}
                    <Grid item xs={12} sm={4}>
                        <Card sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" mb={2}>
                                    <Avatar src={user.avatar} sx={{ width: 100, height: 100 }} />
                                    <Box sx={{ marginLeft: 2 }}>
                                        <Typography variant="h6">{user.name}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {user.profession || '未设置职业'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {user.company || '未设置公司'}
                                        </Typography>
                                    </Box>
                                </Box>
                                {isEditing ? (
                                    <TextField
                                        label="公司名称"
                                        variant="outlined"
                                        fullWidth
                                        value={user.company || ''}
                                        onChange={(e) => setUser({ ...user, company: e.target.value })}
                                    />
                                ) : (
                                    <Button variant="outlined" color="primary" onClick={() => setIsEditing(true)}>
                                        编辑个人信息
                                    </Button>
                                )}
                            </CardContent>
                        </Card>

                        <Card sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>好友列表</Typography>
                                <List>
                                    {user.friends.map((friend, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={friend} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>

                        <Typography variant="h6" gutterBottom>教育经历</Typography>
                        <Card sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <List>
                                    {user.education.map((edu, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={edu} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>

                        <Typography variant="h6" gutterBottom>职业经历</Typography>
                        <Card sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <List>
                                    {user.workExperience.map((exp, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={exp} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* 中间栏 - 统计信息、教育经历、职业经历、个人动态 */}
                    <Grid  sx={{ marginBottom: 2 }} item xs={12} sm={5}>

                        <Typography variant="h6" gutterBottom>统计信息</Typography>
                        <Box sx={{ display: 'flex', gap: 4, marginBottom: 2 }}>
                            <Typography variant="body1">点赞数量：{user.postsLikedCount}</Typography>
                            <Typography variant="body1">粉丝总数：{user.followersCount}</Typography>
                            <Typography variant="body1">浏览过的岗位：{user.footprints.jobsViewed}</Typography>
                            <Typography variant="body1">查看过的简历：{user.footprints.resumesViewed}</Typography>
                        </Box>


                        <Typography variant="h6" gutterBottom  sx={{ marginBottom: 2 }}>个人动态</Typography>
                        <Card>
                            <CardContent>
                                <List>
                                    {user.userPosts.map((post, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={post} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>

                    </Grid>

                    {/* 右侧栏 - 好友列表、我的收藏、我的关注 */}
                    <Grid item xs={12} sm={3}>

                        <Card sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>我的收藏</Typography>
                                <List>
                                    {user.userFavorites.map((fav, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={fav} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>

                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>我的关注</Typography>
                                <Typography variant="body1">{user.followersCount} 人</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}